<template>
  <Skeletor
    v-for="n in count"
    :key="n"
    :class="props.class"
    :as="as" />
</template>

<script lang="ts" setup>
  import { Skeletor } from 'vue-skeletor';

  const props = withDefaults(
    defineProps<{
      count?: number;
      class?: string;
      as?: string;
    }>(),
    {
      count: 1,
      class: '',
      as: 'div'
    }
  );
</script>
